import 'script-loader!jquery';
import 'script-loader!bootstrap/dist/js/bootstrap.bundle.min.js';
import 'script-loader!smartmenus';
import 'hamburgers/dist/hamburgers.css';
import AOS from 'aos';
import fancybox from '@fancyapps/fancybox';
import 'smartmenus/dist/css/sm-core-css.css';
import 'smartmenus/dist/css/sm-simple/sm-simple.scss';
import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import '../scss/entryPalmetto.scss';
import transformButtons from './transformButtons';
import captainsTips from './captainsTips';

jQuery(document).ready(function($) {

	const captainsSwiper = document.querySelector(".swiper.captains__lower--container");
	const allFHButtons = Array.from(document.querySelectorAll('.fh-button'));

	if (captainsSwiper) {
		const swiper = new Swiper('.swiper.captains__lower--container', {
			modules: [Navigation, Autoplay],
			navigation: {
				nextEl: '.swiper-button-next.captains__arrows--next',
				prevEl: '.swiper-button-prev.captains__arrows--prev'
			},
			autoplay: {
				delay: parseInt(captainsSwiper.dataset.swiperSpeed),
				pauseOnMouseEnter: true,
			},
			slidesPerView: 1,
			spaceBetween: 33,
			loop: true,
			breakpoints: {
				450: {
					slidesPerView: 2
				},
				768: {
					slidesPerView: 3
				}
			}
		})
	}

	const singleActivitySwiper = new Swiper('.swiper.activity__images--wrapper', {
		modules: [Navigation],
		navigation: {
			nextEl: '.activity__images--slider-button-next.swiper-button-next',
			prevEl: '.activity__images--slider-button-prev.swiper-button-prev'
		},
		slidesPerView: 1,
		spaceBetween: 0,
		loop: true
	})

	// Postcard flip on click
	// const allPostcards = Array.from(document.querySelectorAll('.postcards-flip__postcard'));

	// if (allPostcards.length > 0) {
	// 	allPostcards.forEach(postcard => {
	// 		postcard.addEventListener('click', (e) => {
	// 			if (postcard.classList.contains('flipped')) {
	// 				postcard.classList.remove('flipped');
	// 			} else {
	// 				postcard.classList.add('flipped');
	// 			}
	// 		})
	// 	})
	// }

	// Title Accordions
	$('.title-accordion-toggle').on('click', function(e) {
		$(this).siblings('.title-accordion-content').slideToggle('fast');
		$(this).find('.title-accordion-toggle-text').toggleClass('accordion-active');
	})

	// Simple Accordions
	$('.accordion-toggle').on('click', function(e) {
		$(this).siblings('.accordion-content').slideToggle('fast');
		$(this).find('.accordion-toggle-text').toggleClass('accordion-active');
	})
	
	// tab content block
	$('.ffw-tabber').on('click', function() {
		$(this).siblings().removeClass('active');
	});
	
	// desktop header search toggle
	$('li.dt-search a').on('click', function() {
		$(this).parent().siblings('.menu-item').toggleClass('hide-menu');
		$(this).children().toggleClass('fa-search fa-times');
		$('.dt-search-wrap').toggleClass('open closed');
		$('.utility-menu > .menu-item').each(function(i) {
			$(this).toggleClass('menu-item-hidden');
		})
	});

	// bootstrap popovers -- see: https://getbootstrap.com/docs/5.0/components/popovers/ for more info
	$(document).ready(function() {
		if($('[data-bs-toggle="popover"]')[0]) {
			var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
			var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
				return new bootstrap.Popover(popoverTriggerEl)
			});
			// dismiss the popover on click
			var popover = new bootstrap.Popover(document.querySelector('.popover-dismiss'), {
				trigger: 'focus'
			});
		}
	});

	// bootstrap tooltips -- see: https://getbootstrap.com/docs/5.0/components/tooltips/ for more info
	$(document).ready(function() {
		if($('[data-bs-toggle="tooltip"]')[0]) {
			var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
			var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
				return new bootstrap.Tooltip(tooltipTriggerEl)
			});
		}
	});

	// hamburger stuffs
	var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};
	var hamburgers = document.querySelectorAll(".hamburger");
	if (hamburgers.length > 0) {
		forEach(hamburgers, function(hamburger) {
			hamburger.addEventListener("click", function() {
				this.classList.toggle("is-active");
			}, false);
		});
	}

	// acf accordions
	$('.acf-accordion .toggle').on('click', function() {
		$(this).next('.toggled').slideToggle('fast');
		$(this).children('.icon').children('.plus-minus').toggleClass('plusser minus');
	});

	// accordions
	$('.accordion-toggle').on('click', function() {
		$(this).next('.accordion-toggled').slideToggle('fast');
		$(this).children('.arrow').toggleClass('arrow-down arrow-up');
		$(this).toggleClass('active');
	});

	// simple accordions
	$('.simple-accordion-toggle').on('click', function() {
		$(this).next('.simple-accordion-toggled').slideToggle('fast');
		$(this).children('.arrow').toggleClass('arrow-down arrow-up');
	});

	// header search toggle
	$('#search-toggle').on('click', function() {
		$(this).toggleClass('glass').toggleClass('close');
		$('#search-box').toggleClass('open');
		$('#top-search').focus();
	});

	// fancybox
	$(document).ready(function() {
		$("a.fancybox").fancybox({
			'transitionIn'	:	'elastic',
			'transitionOut'	:	'elastic',
			'speedIn'		:	600, 
			'speedOut'		:	200, 
			'overlayShow'	:	false
		});
	});

	// add responsive class to all images
	$(function() {
		$('img').addClass('img-fluid');
	});

	// primary menu
	$(function() {
		$('.sm').smartmenus({
			subMenusSubOffsetX: 0,
			subMenusSubOffsetY: -1
		});
	});

	// primary navigation toggle
	$('.nav-toggle').on('click', function() {
		$('.primary-nav-wrap').slideToggle('fast');
	});

	// scroll back to top button
	$(document).ready(function($){
		// browser window scroll (in pixels) after which the "back to top" link is shown
		var offset = 300,
			//browser window scroll (in pixels) after which the "back to top" link opacity is reduced
			offset_opacity = 1200,
			//duration of the top scrolling animation (in ms)
			scroll_top_duration = 300,
			//grab the "back to top" link
			$back_to_top = $('.cd-top');
		//hide or show the "back to top" link
		$(window).scroll(function(){
			( $(this).scrollTop() > offset ) ? $back_to_top.addClass('cd-is-visible') : $back_to_top.removeClass('cd-is-visible cd-fade-out');
			if( $(this).scrollTop() > offset_opacity ) { 
				$back_to_top.addClass('cd-fade-out');
			}
		});
		//smooth scroll to top
		$back_to_top.on('click', function(event){
			event.preventDefault();
			$('body,html').animate({
				scrollTop: 0 ,
				}, scroll_top_duration
			);
		});
	});

	// header scroll effects
	(function () {
		var previousScroll = 0;
		$(window).scroll(function(){
			var scrollTop = $(window).scrollTop();
			var currentScroll = $(this).scrollTop();
			if (currentScroll > previousScroll && currentScroll > 150) {
				$('#masthead').addClass('scrolling-down');
				$('#masthead').removeClass('scrolling-up');
			} else if (currentScroll < previousScroll) {
				$('#masthead').addClass('scrolling-up');
				
				$('#masthead').removeClass('scrolling-down');
			}
			if (scrollTop == 0) {
				$('#masthead').removeClass('scrolling-up');
			}
			previousScroll = currentScroll;
		});
	}());

	// animate on scroll init
	const throttle = (func, delay) => {
		let prev = 0;
		return (...args) => {
			let now = new Date().getTime();

			if (now - prev > delay) {
				prev = now;
				return func(...args);
			}
		}
	}
	AOS.init({ once: true, duration: 700 });
	$(window).on("scroll", throttle( function() { AOS.refresh() }, 500));

	// single activity tabs
	const activityTabs = Array.from(document.querySelectorAll('.activity__tab'));

	if (activityTabs.length > 0) {
		activityTabs.forEach(tab => {
			tab.addEventListener('click', (e) => {
				const thisTab = e.target.closest('.activity__tab');

				if (thisTab.classList.contains('tab-active')) {
					return;
				} else {
					const previousTab = document.querySelector('.activity__tab.tab-active');

					if (previousTab) {
						const previousTabId = previousTab.dataset.tabId;
						const inactiveIcon = previousTab.querySelector('.activity__tab--icon-inactive');
						const activeIcons = Array.from(previousTab.querySelectorAll('.tab-active'));

						activeIcons.forEach(icon => {
							icon.classList.remove('tab-active');
						})

						inactiveIcon.classList.remove('tab-inactive');
						const previousContent = document.querySelector(`[data-tab-content='${previousTabId}']`);
						previousTab.classList.remove('tab-active');

						if (previousContent) {
							previousContent.classList.remove('content-active');
						}
					}

					thisTab.classList.add('tab-active');
					const thisTabId = thisTab.dataset.tabId;
					thisTab.querySelector('.activity__tab--icon').classList.add('tab-active');
					thisTab.querySelector('.activity__tab--icon-active').classList.add('tab-active');
					thisTab.querySelector('.activity__tab--icon-inactive').classList.add('tab-inactive');
					document.querySelector(`[data-tab-content='${thisTabId}']`).classList.add('content-active');
				}
			})
		})
	}

	// Video replaces placeholder
	const imageWraps = Array.from(document.querySelectorAll('.video-container'));
	imageWraps.forEach(function (wrap) {
		wrap.addEventListener('click', function (e) {
			const videoId = wrap.dataset.video;
			const iframe = document.createElement('iframe');
			iframe.setAttribute('width', '100%');
			iframe.setAttribute('height', '100%');
			iframe.setAttribute('src', `${videoId}`);
			iframe.setAttribute('frameborder', '0');
			iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
			iframe.setAttribute('allowfullscreen', '');
			iframe.setAttribute('title', 'YouTube video player');
			iframe.classList.add('responsive-iframe');
			wrap.innerHTML = '';
			wrap.appendChild(iframe);
		});
	});

	// Plan By Interest Tabs
	const pbiTabs = Array.from(document.querySelectorAll('.pbi__tab--button'));

	if (pbiTabs.length > 0) {
		pbiTabs.forEach(pbiTab => {
			pbiTab.addEventListener('click', (e) => {
				const thisTab = e.target.closest('.pbi__tab--button');

				if (thisTab.classList.contains('tab-active')) {
					return;
				}

				const closestUl = thisTab.closest('.pbi__tabs');
				const closestContainer = thisTab.closest(".section-wrap");
				const prevActive = closestUl.querySelector('.tab-active');
				const prevSelector = prevActive.dataset.interestTab;
				const prevContent = closestContainer.querySelector(`[data-interest-block='${prevSelector}']`);

				if (prevActive) {
					prevActive.classList.remove('tab-active');
				}

				if (prevContent && prevContent.classList.contains('tab-active')) {
					prevContent.classList.remove('tab-active');
				}

				const newSelector = thisTab.dataset.interestTab;
				const newContent = closestContainer.querySelector(`[data-interest-block='${newSelector}']`);

				if (newContent) {
					newContent.classList.add('tab-active');
					thisTab.classList.add('tab-active');
				}
			})
		})
	}

	// Fifty Fifty Gallery Text Gallery
	const allFFGTLinks = Array.from(document.querySelectorAll('.ffgt__container'));

	if (allFFGTLinks.length > 0) {
		allFFGTLinks.forEach(ffgt => {
			const ffgtImages = Array.from(ffgt.querySelectorAll('.ffgt__gallery--image-link'));
			const containersModal = ffgt.querySelector('.ffgt__modal--wrapper');
			const containersModalNext = ffgt.querySelector('.ffgt__modal--next');
			const containersModalPrev = ffgt.querySelector('.ffgt__modal--prev')

			if (ffgtImages.length > 0) {
				ffgtImages.forEach(img => {
					img.addEventListener('click', (e) => {
						const closestImg = e.target.closest(".ffgt__gallery--image-link");
						const slideToShow = parseInt(closestImg.dataset.slideNumber);
						let ffgtSwiper = new Swiper(containersModal, {
							modules: [Navigation],
							navigation: {
								nextEl: containersModalNext,
								prevEl: containersModalPrev
							},
							slidesPerView: 1,
							spaceBetween: 0,
							loop: true,
							initialSlide: slideToShow
						})

						if (ffgtSwiper) {
							$(document).on('afterClose.fb', function(e, instance, slide) {
								ffgtSwiper.destroy();
							})
						}
					})
				})
			}
		})
	}

	// Image Gallery Gallery
	const allIGLinks = Array.from(document.querySelectorAll('.image-gallery__container'));

	if (allIGLinks.length > 0) {
		allIGLinks.forEach(ig => {
			const igImages = Array.from(ig.querySelectorAll('.image-gallery__gallery--image-link'));
			const containersModal = ig.querySelector('.image-gallery__modal--wrapper');
			const containersModalNext = ig.querySelector('.image-gallery__modal--next');
			const containersModalPrev = ig.querySelector('.image-gallery__modal--prev')

			if (igImages.length > 0) {
				igImages.forEach(img => {
					img.addEventListener('click', (e) => {
						const closestImg = e.target.closest(".image-gallery__gallery--image-link");
						const slideToShow = parseInt(closestImg.dataset.slideNumber);
						let igSwiper = new Swiper(containersModal, {
							modules: [Navigation],
							navigation: {
								nextEl: containersModalNext,
								prevEl: containersModalPrev
							},
							slidesPerView: 1,
							spaceBetween: 0,
							loop: true,
							initialSlide: slideToShow
						})

						if (igSwiper) {
							$(document).on('afterClose.fb', function(e, instance, slide) {
								igSwiper.destroy();
							})
						}
					})
				})
			}
		})
	}

	// Swimming Line Picks Catch
	const mikesPicks = document.querySelector('.swimming-line__picks--container');

	if (mikesPicks && window.innerWidth > 450) {
		const initialMikesPicksRect = mikesPicks.getBoundingClientRect();
		const mikesPicksContainer = mikesPicks.closest('.swimming-line__container');
		let hasBeenSeen = false;
		let isPinned = false;

		if (initialMikesPicksRect.top > 151) {
			hasBeenSeen = true;
		}
		window.addEventListener('scroll', throttle((e) => {
			const mikesPicksRect = mikesPicks.getBoundingClientRect();
			const containerRect = mikesPicksContainer.getBoundingClientRect();

			if (mikesPicksRect.top < 151 && hasBeenSeen && !isPinned) {
				mikesPicks.classList.add("pin-to-top-right");
				isPinned = true;
			} else if (mikesPicksRect.top < 151 && !hasBeenSeen) {
				return;
			} else if (mikesPicksRect.top > 151 && !hasBeenSeen) {
				hasBeenSeen = true;
			} else if (containerRect.top > 151 && hasBeenSeen && isPinned) {
				mikesPicks.classList.remove("pin-to-top-right");
				isPinned = false;
			}
			
		}, 50))
	}

	// home hero video button
	const homeHeroContainer = document.querySelector('.home-hero__container');

	if (homeHeroContainer) {
		const videoButton = homeHeroContainer.querySelector('.home-hero__video--sound-button');

		if (videoButton) {
			const homeVideo = homeHeroContainer.querySelector('.home-hero__video');
			videoButton.addEventListener('click', (e) => {
				if (homeVideo.muted) {
					homeVideo.muted = false;
					videoButton.classList.add('sound-active');
				} else {
					homeVideo.muted = true;
					videoButton.classList.remove('sound-active');
				}
			})
		}
	}

	// Transforming buttons generated by fareharbor plugin
	transformButtons();
	
	document.addEventListener('facetwp-loaded', () => {
		transformButtons();
	})

	// Captain tooltip event listeners
	const captainContainer = document.querySelector('.captains__container');

	if (captainContainer) {
		const captainFWPContainer = captainContainer.querySelector('.facetwp-facet');

		if (captainFWPContainer) {
			document.addEventListener('facetwp-loaded', () => {
				captainsTips();
			})
		} else {
			captainsTips();
		}
	}

});